import { deleteDeductionItem } from "@/api/deduction-items";
import { Button } from "@/components/ui/button";
import {
  DeductionItem,
  DeductionItemType,
  DeductionItemTypeLabels,
} from "@/models/deduction-items.model";
import { ColumnDef } from "@tanstack/react-table";

const ActionCell = ({
  row,
  deleteDeductionItemCallback,
}: {
  row: any;
  deleteDeductionItemCallback: (id: number) => void;
}) => {
  const handleDeleteDeductionItem = async () => {
    try {
      const res = await deleteDeductionItem(row.original.id);

      if (res) {
        deleteDeductionItemCallback(row.original.id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Button variant="outline" onClick={handleDeleteDeductionItem}>
      Delete
    </Button>
  );
};
export const getColumns = (
  deleteDeductionItem: (id: number) => void
): ColumnDef<DeductionItem>[] => [
  {
    accessorFn: (row) => row.type,
    cell: ({ row }) => {
      return (
        <span>
          {DeductionItemTypeLabels[row.original.type as DeductionItemType]}
        </span>
      );
    },
    header: "Type",
  },
  {
    accessorFn: (row) => row.amount,
    cell: ({ row }) => {
      return <span>{row.original.amount}</span>;
    },
    header: "Amount ($)",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <ActionCell deleteDeductionItemCallback={deleteDeductionItem} row={row} />
    ),
  },
];
